module.exports = __webpack_public_path__ + "static/media/icon-asset-video-indicator.ce11ac6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/album-view/images/icon-asset-video-indicator.svg
// module id = 1023
// module chunks = 57